<template>
    <div class="loading" v-if="configin && $store.state.storeforload">
      <div class="senda loading-brand" v-if="configin.shopname == 'senda'">
        <span >S</span>
        <span >E</span>
        <span >N</span>
        <span >D</span>
        <span >A</span>
      </div>
      <div class="basto loading-brand" v-if="configin.shopname == 'basto'">
        <span >B</span>
        <span >A</span>
        <span >S</span>
        <span >T</span>
        <span >O</span>
      </div>
      <div class="staccato loading-brand" v-if="configin.shopname == 'staccato'">
        <span >S</span>
        <span >T</span>
        <span >A</span>
        <span >C</span>
        <span >C</span>
        <span >A</span>
        <span >T</span>
        <span >O</span>
      </div>
      <div class="loading-tips">
          <span class="loading-text-words">科</span>
          <span class="loading-text-words">技</span>
          <span class="loading-text-words">·</span>
          <span class="loading-text-words">舒</span>
          <span class="loading-text-words">适</span>
          <span class="loading-text-words">·</span>
          <span class="loading-text-words">匠</span>
          <span class="loading-text-words">心</span>
      </div>
      <div class="foottext">请求数据...</div>
    </div>
</template>

<script>

import config from '@/conf/index'

export default {
    data(){
        return {
          configin: null, // config的映射
        }
    },
    props: {
        titleInfo: {
            type: String,
        },
    },
    watch: {
    },
    mounted(){
          this.configin = config
    },
    methods: {
    }
}
</script>

<style scoped lang="less">
   /*@import url(https://fonts.googleapis.com/css?family=Quattrocento+Sans);*/
  .loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #fff;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: @base;
    font-family: PingFangSC, Arial, Helvetica, '宋体';
  }
  .loading-brand {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .loading-tips,
  .loading-brand {
    width: 100%;
    height: 5%;
  }
  .loading-tips span,
  .loading-brand span {
    display: inline-block;
    margin: 0px;
  }
  .foottext {
    margin-left: 6px;
  }
  .loading-tips span:nth-child(1) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.0s infinite linear alternate;
  }
  .loading-tips span:nth-child(2) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.143s infinite linear alternate;
  }
  .loading-tips span:nth-child(3) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.286s infinite linear alternate;
  }
  .loading-tips span:nth-child(4) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.429s infinite linear alternate;
  }
  .loading-tips span:nth-child(5) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.572s infinite linear alternate;
  }
  .loading-tips span:nth-child(6) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.715s infinite linear alternate;
  }
  .loading-tips span:nth-child(7) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.858s infinite linear alternate;
  }
  .loading-tips span:nth-child(8) {
      filter: blur(0px);
      animation: blur-text 1.5s 1.0s infinite linear alternate;
  }



  /*senda部分*/
  .senda span:nth-child(1) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.0s infinite linear alternate;
  }
  .senda span:nth-child(2) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.25s infinite linear alternate;
  }
  .senda span:nth-child(3) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.5s infinite linear alternate;
  }
  .senda span:nth-child(4) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.75s infinite linear alternate;
  }
  .senda span:nth-child(5) {
      filter: blur(0px);
      animation: blur-text 1.5s 1.0s infinite linear alternate;
  }

  /*basto部分*/
  .basto span:nth-child(1) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.0s infinite linear alternate;
  }
  .basto span:nth-child(2) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.25s infinite linear alternate;
  }
  .basto span:nth-child(3) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.5s infinite linear alternate;
  }
  .basto span:nth-child(4) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.75s infinite linear alternate;
  }
  .basto span:nth-child(5) {
      filter: blur(0px);
      animation: blur-text 1.5s 1.0s infinite linear alternate;
  }

  /*staccato部分*/
  .staccato span:nth-child(1) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.0s infinite linear alternate;
  }
  .staccato span:nth-child(2) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.14s infinite linear alternate;
  }
  .staccato span:nth-child(3) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.28s infinite linear alternate;
  }
  .staccato span:nth-child(4) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.42s infinite linear alternate;
  }
  .staccato span:nth-child(5) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.56s infinite linear alternate;
  }
  .staccato span:nth-child(6) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.7s infinite linear alternate;
  }
  .staccato span:nth-child(7) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.84s infinite linear alternate;
  }
  .staccato span:nth-child(8) {
      filter: blur(0px);
      animation: blur-text 1.5s 0.98s infinite linear alternate;
  }

  @-webkit-keyframes blur-text {
      0% {
          -webkit-filter: blur(0px);
          filter: blur(0px);
      }
      100% {
          -webkit-filter: blur(4px);
          filter: blur(4px);
      }
  }
  @keyframes blur-text {
      0% {
          -webkit-filter: blur(0px);
          filter: blur(0px);
      }
      100% {
          -webkit-filter: blur(4px);
          filter: blur(4px);
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/loads.vue